import { enableProdMode, InjectionToken } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { settings, Settings } from './settings/settings';

const settingsProviders = Settings.initializeProviders();

console.log(settings.envName);
document.title = settings.title;

export const VERSION_INFO = new InjectionToken<VersionInfo>('VERSION_INFO');
export interface VersionInfo {
  version: string;
}

const fetchVersion = () => fetch('/version.json').then(value => value.json() as Promise<VersionInfo>);

if (settings.envName === 'Prod') {
  enableProdMode();
}

fetchVersion().then(versionInfo => {
  platformBrowserDynamic([...settingsProviders, { provide: VERSION_INFO, useValue: versionInfo }])
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
